<div class="localization-card">
  <div class="localization-icon"><mat-icon svgIcon="marker"></mat-icon></div>
  <div class="localization-info">
    <p>{{ 'OPTIONS.LOCATION' | translate }}</p>
    <p class="location">Águas Claras, Distrito Federal</p>
  </div>
  <mat-icon
    class="icon-arrow"
    svgIcon="arrow"
    (click)="openBottomSheetLocation()"
  ></mat-icon>
</div>
